import _ from 'underscore';

export function filterLocationData({ data, granularity, metric }) {
  return _.filter(data, item => item[granularity.name] && item[granularity.latitude] && item[granularity.longitude] && item[metric]);
}
